import { FormControl } from '@material-ui/core';
import { Button } from 'primereact/button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import 'date-fns';
import { useFormik } from 'formik';
import * as React from 'react';
import * as yup from 'yup';
import dayjs from 'dayjs';
const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));


const validationSchema = yup.object().shape({
  costSavings: yup
    .number('Cost Saving must be a number')
    .typeError('Cost Saving must be a number')
    .required('Cost Saving is required'),
  mobileNo: yup
    .string()
    .matches(/^\d{10}$/, 'Mobile Number must be 10 digits')
    .required('Mobile Number is required'),
  doa: yup
    .date('Admission Date must be a valid date')
    .typeError('Admission Date must be a valid date')
    .required('Admission Date is required'),
  remarks: yup.string().required('Remark is required'),
});

export default function DischargeUpdationModal(props) {
  const classes = useStyles();


  const formik = useFormik({
    initialValues: {
      action: 'ADMISSION_UPDATION',
      estimatedCost: props.data?.estimatedCost || '',
      approvedAmount: props.data?.approvedAmount || '',
      costSavings: 0,
      mobileNo:  props?.admissionRelatedData?.contactNoOne,
      doa: dayjs(props?.admissionRelatedData?.expectedDOA)?.format("YYYY-MM-DDTHH:mm"),
      remarks: '',
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const doa = new Date(values.doa);
      const timestampMilliseconds = doa.getTime();

      const updatedValues = {
        ...values,
        doa: timestampMilliseconds,
      };

      props.admissionUpdationModalSubmit(updatedValues)
      props.handleCloseClaimModal();
    },
  });
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState('sm');


  const handleClose = () => {
    props.handleCloseClaimModal();
  };
  const handleEdit = (e) => {
    // setState({ [`${e.target.name}`]: e.target.value });
  }
  const handleModalSubmit = () => {
    formik.handleSubmit();

  };

  return (
    <Dialog
      open={props.admissionUpdationModal}
      onClose={handleClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-labelledby="form-dialog-title"
      disableEnforceFocus>
      <DialogTitle id="form-dialog-title">Admission Updation</DialogTitle>
      <DialogContent>
        <Grid container spacing={3} style={{ marginBottom: '20px' }}>

          <Grid item xs={6}>
            <TextField
              id="estimatedCost"
              name="estimatedCost"
              value={formik.values.estimatedCost}
              onChange={formik.handleChange}
              label="Estimated Amount"
              inputProps={
                { readOnly: true, }
              }
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="approvedAmount"
              name="approvedAmount"
              value={formik.values.approvedAmount}
              onChange={formik.handleChange}
              label="Sanction Amount"
              inputProps={
                { readOnly: true, }
              }
            />
          </Grid>

          <Grid item xs={6}>
            <FormControl>

              <TextField
                id="costSavings"
                name="costSavings"
                value={formik.values.costSavings}
                onChange={formik.handleChange}
                type="number"
                label="Cost Savings *"
                helperText={formik.touched.costSavings && formik.errors.costSavings}
                error={formik.touched.costSavings && Boolean(formik.errors.costSavings)}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl>
              <TextField
                id="mobileNo"
                name="mobileNo"
                value={formik?.values?.mobileNo}
                onChange={formik.handleChange}
                label="Mobile Number *"
                helperText={formik.touched.mobileNo && formik.errors.mobileNo}
                error={formik.touched.mobileNo && Boolean(formik.errors.mobileNo)}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl>
              <TextField
                id="doa"
                name="doa"
                onChange={formik.handleChange}
                label="Admisssion Date *"
                type="datetime-local"
                defaultValue="2017-05-24T10:30"
                value={formik.values.doa}
                className={classes.textField}
                helperText={formik.touched.doa && formik.errors.doa}
                error={formik.touched.doa && Boolean(formik.errors.doa)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField id="remarks"
                onChange={formik.handleChange}
                name="remarks"
                value={formik.values.remarks}
                label="Remark *"
                multiline
                minRows={5}
                helperText={formik.touched.remarks && formik.errors.remarks}
                error={formik.touched.remarks && Boolean(formik.errors.remarks)}
              />
            </FormControl>
          </Grid>

        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" className='p-button-text'>
          Cancel
        </Button>
        <Button onClick={handleModalSubmit} color="primary">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
